export const FOUNDERS = [
  { id: "sumit", name: "Mr. Sumit Lathia", role: "Founder", img: "/images/founders/sumit-lathia.png", pos: "object-[50%_30%]" },
  { id: "mitesh", name: "Mr. Mitesh Patel", role: "Founder", img: "/images/founders/mitesh-patel.jpg", pos: "object-[50%_20%]" },
];

export function FounderCard({ f, testid, tilt }) {
  return (
    <div className="relative group" data-testid={testid}>
      <div className={`absolute -inset-2.5 rounded-[2.3rem] border gold-border transition-transform duration-700 group-hover:rotate-0 ${tilt}`} />
      <div className="relative rounded-[2rem] overflow-hidden bg-gradient-to-b from-[#EEEAE0] to-[#D7D4CF] aspect-[4/5]">
        <img src={f.img} alt={`${f.name} — ${f.role}, Fresio Herbals`} className={`w-full h-full object-cover ${f.pos} transition-transform duration-[1400ms] group-hover:scale-105`} />
        <div className="absolute inset-x-0 bottom-0 p-3 sm:p-5 bg-gradient-to-t from-[#1D3A2F]/95 via-[#1D3A2F]/40 to-transparent">
          <div className="text-[9px] sm:text-[10px] tracking-[0.28em] uppercase text-[#E6D5A4] mb-0.5">{f.role}</div>
          <div className="font-editorial text-base sm:text-2xl leading-tight text-[#FDFBF7]">{f.name}</div>
          <div className="hidden sm:block text-xs text-[#FDFBF7]/70 mt-0.5">Fresio Herbals</div>
        </div>
      </div>
    </div>
  );
}
